import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const engagementInsights = [
  {
    icon: 'ri-focus-3-line',
    title: 'Atenção plena, sem dispersão',
    description: 'Com o áudio direto no ouvido, o participante bloqueia naturalmente conversas paralelas, notificações de celular e ruídos do ambiente. O foco no conteúdo chega a níveis que caixas de som jamais alcançam.',
  },
  {
    icon: 'ri-volume-up-line',
    title: 'Volume individual = experiência personalizada',
    description: 'Cada pessoa ajusta o volume no seu fone. Quem tem audição sensível não sofre. Quem quer mais intensidade aumenta. Ninguém depende da posição na sala para ouvir bem.',
  },
  {
    icon: 'ri-chat-3-line',
    title: 'Interatividade que o som ambiente mata',
    description: 'Em palestras tradicionais, perguntas da plateia se perdem. Com fones, o microfone do participante vai direto para todos os fones — cada pergunta é ouvida com clareza por 100% da audiência.',
  },
];

const orgInsights = [
  {
    icon: 'ri-layout-masonry-line',
    title: 'Múltiplas sessões, um único espaço',
    description: 'A maior revolução organizacional: 3 palestras simultâneas no mesmo salão. Cada grupo no seu canal. O custo de locação de salas extras simplesmente desaparece.',
  },
  {
    icon: 'ri-timer-line',
    title: 'Montagem e desmontagem em minutos',
    description: 'Nada de soundcheck de 2 horas, nada de cabos pelo chão, nada de caixas de som pesadas. A infraestrutura de uma palestra silenciosa cabe em 2 cases e fica pronta em 20 minutos.',
  },
  {
    icon: 'ri-global-line',
    title: 'Interpretação sem cabine, sem limite',
    description: 'Tradução simultânea para até 10 idiomas via canais dedicados. Os intérpretes trabalham de qualquer sala com microfone — elimina-se o custo e a complexidade das cabines tradicionais.',
  },
];

export default function InsightsSection() {
  const { ref: engHeaderRef, isVisible: engHeaderVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: engGridRef, isVisible: engGridVisible } = useScrollAnimation({ threshold: 0.05 });
  const { ref: orgHeaderRef, isVisible: orgHeaderVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: orgGridRef, isVisible: orgGridVisible } = useScrollAnimation({ threshold: 0.05 });

  return (
    <>
      {/* Engagement section */}
      <section className="py-20 md:py-32 bg-white">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div ref={engHeaderRef} className="text-center mb-16">
            <span className="font-body text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-4 block">
              Insights
            </span>
            <h2
              className={`font-heading font-bold text-4xl md:text-6xl text-secondary mb-6 transition-all duration-700 ${engHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              como elevar o<br />engajamento
            </h2>
            <p
              className={`font-body text-lg text-gray-500 max-w-2xl mx-auto transition-all duration-700 delay-150 ${engHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              A palestra silenciosa muda a dinâmica de atenção do seu evento — e os números comprovam
            </p>
          </div>

          <div ref={engGridRef} className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {engagementInsights.map((item, i) => (
              <div
                key={i}
                className={`bg-gray-50 border border-gray-100 rounded-2xl p-6 md:p-8 text-center hover:-translate-y-1 transition-all duration-500 ${engGridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary/10 mx-auto mb-5">
                  <i className={`${item.icon} text-primary text-2xl`} />
                </div>
                <h3 className="font-heading font-bold text-lg text-secondary mb-3">{item.title}</h3>
                <p className="font-body text-sm text-gray-600 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Organization section */}
      <section className="py-20 md:py-32 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div ref={orgHeaderRef} className="text-center mb-16">
            <span className="font-body text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-4 block">
              Insights
            </span>
            <h2
              className={`font-heading font-bold text-4xl md:text-6xl text-secondary mb-6 transition-all duration-700 ${orgHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              como simplificar a<br />organização
            </h2>
            <p
              className={`font-body text-lg text-gray-500 max-w-2xl mx-auto transition-all duration-700 delay-150 ${orgHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              Menos estrutura, menos custo, menos complexidade — mais resultado
            </p>
          </div>

          <div ref={orgGridRef} className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {orgInsights.map((item, i) => (
              <div
                key={i}
                className={`bg-white border border-gray-100 rounded-2xl p-6 md:p-8 text-center hover:-translate-y-1 transition-all duration-500 ${orgGridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary/10 mx-auto mb-5">
                  <i className={`${item.icon} text-primary text-2xl`} />
                </div>
                <h3 className="font-heading font-bold text-lg text-secondary mb-3">{item.title}</h3>
                <p className="font-body text-sm text-gray-600 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}